<template>
    <page>
        <module>
            <module-tab title="平台配置">
                <c-form ref="form1">
                    <c-form title="基本配置">
                        <c-form-item type="number" decimal="1" label="订单自动关闭" name="ORDER_AUTO_CLOSE_TIME"  :limit="[0.1,999]" input-unit="时" word="注:下单后超过该时间还未完成支付，则订单自动关闭"></c-form-item>
                        <!-- <c-form-item type="radio" label="缺货订购" :options="switchOptions"  name="IS_OUTSTOCK"
                                     word="注:开启缺货订购后，具体哪些商品支持缺货订购需要在商品发布时自行指定"></c-form-item> -->
                        <c-form-item type="number" label="服务完成自动验收" name="ORDER_CONFIRM_DATE" :limit="[0,100]" input-unit="天" word="订单服务完成后，超过X天未确认验收,系统将自动验收"></c-form-item>
                        <!-- <c-form-item type="number" label="退货政策期" name="ORDER_RETURN_POLICY_PERIOD" :limit="[0,999]" input-unit="天" word="服务完成并验收后，X天内允许发起退款申请"></c-form-item> -->
                        <!-- <c-form-item type="number" decimal="2" label="订单包邮金额" name="FREE_POSTAGE_ORDER_PRODUCT_MONEY" :limit="[0.01,99999999]" input-unit="元" word="单个订单商品金额≥该数值，则不收取邮费（不配置默认不包邮）"></c-form-item> -->
                        <!-- <c-form-item type="number" decimal="0" label="订单包邮数量" name="FREE_POSTAGE_ORDER_PRODUCT_COUNT" :limit="[1,99999999]" input-unit="件" word="单个订单商品数量≥该数值，则不收取邮费（不配置默认不包邮）"></c-form-item> -->
                        <c-form-item type="input" label="官方店铺名称" name="PLATFORM_SHOP_NAME" maxlength="20" word="购物车、订单等位置展示，最多输入20个字符"></c-form-item>
                        <c-form-item type="radio" label="头像昵称必填" :options="switchOptions"  name="AVATAR_NICKNAME_ENABLED" word="开启后，头像或者昵称未填写则不允许下单"></c-form-item>
                        <!-- <c-form-item type="radio" label="价格低物流优先" :options="switchOptions"  name="SYS_LOGISTICS_COMPANY_PRICE_PRIORITY_ENABLED" word="开启：优先展示费用较低的物流公司；关闭：按照后台配置的顺序展示物流公司"></c-form-item> -->
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="财务配置" v-if="systemConfig.account_balance_enabled == 'ON' || systemConfig.credit_pay == 'ON' || systemConfig.pt_mode == '2' || systemConfig.oms_seller_shop_enabled =='ON'">
                <c-form ref="form2">
                    <c-form title="开票配置" v-if="systemConfig.order_invoice_enabled == 'ON'">
                        <c-form-item type="radio" v-if="systemConfig.order_invoice_enabled == 'ON'"
                                     label="专票开票" :options="switchOptions"
                                     name="SPECIAL_INVOICE"
                                     word="注：关闭，则用户无法添加专票开票信息，已存在的专票开票信息将隐藏"></c-form-item>
                    </c-form>
                    <c-form title="会员财务配置" v-if="systemConfig.account_balance_enabled == 'ON' || systemConfig.credit_pay == 'ON'">
                        <c-form-item type="number" v-if="systemConfig.account_balance_enabled == 'ON'" decimal="2" :limit="[0,99]" label="账户提现手续费率" name="WITHDRAWAL_RATE" input-unit="%" word="费率非0时，最低收取0.1元（支持提现时有效）"></c-form-item>
                        <c-form-item type="number" v-if="systemConfig.account_balance_enabled == 'ON'"  decimal="2" :limit="[0.01,9999999]" label="账户单次提现下限" name="A_SINGLE_WITHDRAWAL_MIN" input-unit="元" word="单次提现不小于该数值（支持提现时有效）"></c-form-item>
                        <c-form-item type="number" v-if="systemConfig.account_balance_enabled == 'ON'"  decimal="2" :limit="[0.01,9999999]" label="账户单次提现上限" name="A_SINGLE_WITHDRAWAL_LIMIT" input-unit="元" word="单次提现不超过该数值（支持提现时有效）"></c-form-item>
                        <c-form-item type="radio" v-if="systemConfig.credit_pay == 'ON' && systemConfig.order_invoice_enabled == 'ON'"
                                     label="出账方式" :options="payPeriodType"
                                     name="PAY_PERIOD_TYPE"
                                     word="注：订单需要开票时，选择“开票后”才有意义，否则订单任会在全部发货后完成出账"></c-form-item>
                        <c-form-item type="number" v-if="systemConfig.credit_pay == 'ON'"
                                     label="出账后还款天数" name="PAY_PERIOD_VALUE"  input-unit="天"
                                     word="注：出账后多少天内未完成还款则逾期"></c-form-item>
                    </c-form>
                    <c-form title="商家财务相关配置" v-if="systemConfig.pt_mode == '2' || systemConfig.oms_seller_shop_enabled =='ON'">
                        <c-form-item type="number" decimal="2" :limit="[0,99]" label="账户提现手续费率" name="STATION_WITHDRAWAL_RATE"  input-unit="%" word="费率非0时，最低收取0.1元"></c-form-item>
                        <c-form-item type="number" decimal="2" :limit="[0.01,9999999]" label="账户单次提现上限" name="STATION_A_SINGLE_WITHDRAWAL_LIMIT" input-unit="元" word="单次提现不超过该数值"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="显示配置" v-if="systemConfig.mobile_enabled == 'ON'||systemConfig.pc_enabled == 'ON'">
                <c-form ref="form3">
                    <c-form title="移动端配置" v-if="systemConfig.mobile_enabled == 'ON'">
                        <c-form-item type="image" label="移动端登陆页Logo" name="SYS_APP_LOGIN_LOGO_IMG" word="移动端登录页显示的Logo,【建议尺寸：180X180px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="用户默认头像" name="DEFAULT_HEAD_PHOTO" file-word="用户未设置头像则默认展示该图片作为头像【建议尺寸：150X150px,支持jpg、png，图片大小1M以内】" ></c-form-item>
                    </c-form>
                    <c-form title="PC基础配置" v-if="systemConfig.pc_enabled == 'ON'">
                        <c-form-item type="input" label="PC平台名称" name="PLATFORM_NAME"></c-form-item>
                        <c-form-item type="image" label="PC网站ICON图标" name="PLATFORM_PC_FAVICON" file-word="PC网站ICON图标,【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="PC商城（主）Logo" name="PLATFORM_PC_LOGO_BIG" file-word="PC首页、商品列表等页面显示,【建议尺寸：高度100px,宽度560px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="PC商城（小）Logo" name="PLATFORM_PC_LOGO_SMALL" file-word="PC购物车、下单等页面显示,【建议尺寸：130X80px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="textarea" label="网站描述" name="PC_DESCRIPTION"   ></c-form-item>
                        <c-form-item type="textarea" label="网站关键词" name="PC_KEYWORDS"   ></c-form-item>
                        <c-form-item type="input" label="ICP备案信息" name="ICP"   ></c-form-item>
                        <c-form-item type="input" label="公安备案信息" name="BEIAN"></c-form-item>
                        <c-form-item type="input" label="公安备案链接" name="BEIAN_LINK"></c-form-item>
                        <c-form-item type="input" label="电信许可证号" name="TELE_LICENCE_NUMBER"></c-form-item>
                        <c-form-item type="image" label="电信许可证图片" name="TELE_LICENCE_IMG" file-word="请上传电信许可证图片信息,【支持jpg、jpeg、png】"></c-form-item>
                        <c-form-item type="input" label="版权信息" name="COPYRIGHT"   ></c-form-item>
                    </c-form>
                    <c-form title="PC其他配置" v-if="systemConfig.pc_enabled == 'ON'">
                        <c-form-item type="image" label="二维码1图" name="ITEM1_IMG" file-word="首页底部/侧边栏等处使用,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="input" label="二维码1名称" name="ITEM1_TITLE" word="首页底部/侧边栏等处使用" ></c-form-item>
                        <c-form-item type="image" label="二维码2图" name="ITEM2_IMG" file-word="首页底部/侧边栏等处使用,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="input" label="二维码2名称" name="ITEM2_TITLE" word="首页底部/侧边栏等处使用" ></c-form-item>
                        <c-form-item type="input" label="客服电话" name="CUSTOMER_SERVICE_PHONE"></c-form-item>
                        <c-form-item type="input" label="联系邮箱" name="CUSTOMER_SERVICE_EMAIL"></c-form-item>
                        <c-form-item type="editor" label="登录页底部导航" name="PC_BOTTOM_NAV"></c-form-item>
                        <c-form-item type="editor" label="页面底部通用导航" name="COMMON_NAV"></c-form-item>
                        <c-form-item type="editor" label="订购说明" name="ORDER_REMARK"   ></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="管理后台配置">
                <c-form ref="form4">
                    <c-form title="运营后台配置">
                        <c-form-item type="input" label="系统名称" name="OMS_SYSTEM_NAME"></c-form-item>
                        <c-form-item type="image" label="登录页Logo" name="OMS_LOGIN_LOGO" file-word="【建议尺寸：140X140px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="内页Logo" name="OMS_LOGO" file-word="【建议尺寸：200X150px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
                        <c-form-item type="image" label="ICON图标" name="OMS_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="input" label="版权信息" name="OMS_COPYRIGHT" ></c-form-item>
                    </c-form>
                    <c-form title="商家后台配置" v-if="systemConfig.pt_mode == '2'">
                        <c-form-item type="input" label="系统名称" name="SCS_SYSTEM_NAME"></c-form-item>
                        <c-form-item type="image" label="登录页Logo" name="SCS_LOGIN_LOGO" file-word="【建议尺寸：高度140px,宽度600px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="image" label="内页Logo" name="SCS_LOGO" file-word="【建议尺寸：400X88px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
                        <c-form-item type="image" label="ICON图标" name="SCS_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
                        <c-form-item type="input" label="版权信息" name="SCS_COPYRIGHT" ></c-form-item>
                        <c-form-item type="input" label="招商电话" name="SCS_INVESTMENT_HOTLINE" ></c-form-item>
                        <c-form-item type="input" label="客服电话" name="SCS_CUSTOMER_SERVICE_TELEPHONE" ></c-form-item>
                        <c-form-item type="input" label="默认欢迎语" name="DEFAULT_WELCOME_MESSAGE" word="商家未配置在线聊天欢迎语，则默认使用该欢迎语"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <module-tab title="平台政策说明" v-if="systemConfig.pc_enabled == 'ON'">
                <c-form ref="form5">
                    <c-form-item type="textarea" label="配送信息" name="DELIVERY_REMARK"></c-form-item>
                    <c-form-item type="textarea" label="支付方式" name="PAYMENT_REMARK"></c-form-item>
                    <c-form-item type="textarea" label="退换货政策" name="RETURN_REMARK"></c-form-item>
                </c-form>
            </module-tab>
            <template slot="button">
                <c-button size="m" power="b_mall_config_edit" @click="save()">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	
    export default {
        name: 'm_mall_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
                payPeriodType:[{
                    name: '发货后',
                    value: '1'
                }, {
                    name: '开票后',
                    value: '2'
                }],
	            occupancyTypeOptions:[{
                    name: '下单后扣减',
                    value: '1'
                }, {
                    name: '支付后扣减',
                    value: '2'
                }],
	            outstockOptions: [{
		            name: '不支持',
		            value: '0'
	            }, {
		            name: '支持',
		            value: '1'
	            }],
            }
        },
        computed: {
          ...mapState(['systemConfig'])
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                          if(item.config_item_code=='STATION_WITHDRAWAL_RATE' || item.config_item_code=='WITHDRAWAL_RATE'){
                            json[item.config_item_code] = parseFloat(item.config_item_value) * 100;
                          }else{
                            json[item.config_item_code] = item.config_item_value;
                          }
                        });
                        this.$nextTick(() => {
                            if(this.$refs.form1)this.$refs.form1.set(json);
                            if(this.$refs.form2)this.$refs.form2.set(json);
                            if(this.$refs.form3)this.$refs.form3.set(json);
                            if(this.$refs.form4)this.$refs.form4.set(json);
                            if(this.$refs.form5)this.$refs.form5.set(json);
                        });
                    }
                });
            },


            save() {
                let data1 = this.$refs.form1?this.$refs.form1.get():{};
                let data2 = this.$refs.form2?this.$refs.form2.get():{};
                let data3 = this.$refs.form3?this.$refs.form3.get():{};
                let data4 = this.$refs.form4?this.$refs.form4.get():{};
                let data5 = this.$refs.form5?this.$refs.form5.get():{};
                let submitData = Object.assign({},data1, data2, data3, data4, data5);
                let platform_config_list = [];
                for (let key in submitData) {
                    if(key=='STATION_WITHDRAWAL_RATE' || key=='WITHDRAWAL_RATE'){
                        platform_config_list.push({
                            config_item_code: key,
                            config_item_value: submitData[key] ? parseFloat(submitData[key].toString()) / 100 : 0
                        });
                    }else{
                        platform_config_list.push({
                            config_item_code: key,
                            config_item_value: submitData[key] ? submitData[key].toString() : ''
                        });
                    }
                }
                this.request({
                    url: '/platform_config/edit',
                    data: {
                        platform_config_list: platform_config_list
                    },
                    loading: true,
                    success: data => {
                        this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                        //刷新页面
                        this.getDetail();
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>


</style>